import { BaseApi } from '@/api/BaseApi.ts'
import type { Paginated } from '@/api/types.ts'
import type {
  WorkflowTemplateData,
  WorkflowTemplateFetchParams,
  WorkflowTemplateInput,
  WorkflowTemplateListItem,
} from '@/api/WorkflowTemplate/types.ts'

class Api extends BaseApi<
  WorkflowTemplateData,
  Paginated<WorkflowTemplateListItem>,
  WorkflowTemplateInput,
  WorkflowTemplateFetchParams
> {
  readonly baseUrl = 'initiatives/:initiativeId/workflow-templates'
}

const WorkflowTemplateApi = new Api()

export default WorkflowTemplateApi
